import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type OrganizationWorkflowCreationFailedAction = {
	type: 'ORGANIZATION_WORKFLOW_CREATION_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): OrganizationWorkflowCreationFailedAction => ({
	type: 'ORGANIZATION_WORKFLOW_CREATION_FAILED',
	payload,
});
